// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import 'element-ui/lib/theme-chalk/index.css';
import { Button, DropdownItem, Dialog, Input, Menu, Submenu, MenuItem, MenuItemGroup, Row, Col, Image, Backtop, Table, TableColumn, Carousel, CarouselItem} from 'element-ui'
import './index.scss'
import './fonts/style.css'

Vue.use(Button).use(DropdownItem).use(Dialog).use(Input).use(Menu).use(Row).use(Col).use(Image).use(Submenu)
.use(MenuItem).use(MenuItemGroup).use(Backtop).use(Table).use(TableColumn).use(Carousel).use(CarouselItem)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js